import Pagination from "../pagination/Pagination";

const FooterHourlyTracking = ({
  currentPage,
  countPerPage,
  countTotal,
  totalPages,
  setCurrentPage,
}) => {
  return (
    <div className={"w-full flex justify-between items-center min-h-[36px]"}>
      <div className={""}></div>
      <div className={""}>
        <Pagination
          currentPage={currentPage}
          countPerPage={countPerPage}
          countTotal={countTotal}
          totalPages={totalPages}
          setCurrentPage={setCurrentPage}
        />
      </div>
    </div>
  );
};

export default FooterHourlyTracking;
